module.exports = __webpack_public_path__ + "75f5ec7f53e0a08bc7cc562b24f2c4d3.png";